import { WEBOS_INTERNAL_RELATIVE_PATH, WEBOS_RELATIVE_PATH } from '@/constants/webOS';
import config from '@/config';
import WebOSStorageManager from '@/utils/internalFileStorage/webOSStorageManager';
import { getAndroidVideoItemKey } from '@/utils/internalFileStorage/androidVideoDownloader';
import { getTizenVideoItemKey } from '@/utils/internalFileStorage/tizenVideoDownloader';

export function getItemLocalUrl(itemUrl, itemId) {
  if (window.isWebOS) {
    try {
      return `${WEBOS_RELATIVE_PATH}/${replaceItemUrlWithFileName(itemUrl, itemId)}`;
    } catch (error) {
      console.error('Failed to get internal files');
    }
  }
  if (window.isAndroid) {
    const videoKey = getAndroidVideoItemKey(itemId);
    if (videoKey && window[videoKey]) {
      return window[videoKey];
    }
  }
  if (window.isTizen) {
    const videoKey = getTizenVideoItemKey(itemId);
    const storedPath = localStorage.getItem(videoKey);
    if (videoKey && storedPath) {
      return `file://${storedPath}`;
    }
  }

  return `${config.baseUrl}/${itemUrl}`;
}

export function getFontLocalUrl(fontUrl, fontId, organisationId) {
  if (window.isWebOS) {
    try {
      return `${WEBOS_RELATIVE_PATH}/${replaceFontUrlWithFileName(
        fontUrl,
        fontId,
        organisationId,
      )}`;
    } catch (error) {
      console.error('Failed to get internal files');
    }
  }

  return fontUrl;
}

export async function fontExistsInInternalStorage(fontUrl, fontId, organisationId) {
  if (window.isWebOS) {
    const path = `${WEBOS_INTERNAL_RELATIVE_PATH}/${replaceFontUrlWithFileName(
      fontUrl,
      fontId,
      organisationId,
    )}`;

    const result = await WebOSStorageManager.exists(path);
    return result.exists;
  }

  return false;
}

// Button images are full URL.
// Can't change that as it will affect backward compatibility therefire buttons need to call this method for local URL.
export function getLocalUrlFromFullUrl(fullUrl, itemId) {
  const regex = new RegExp(`${config.baseUrl}/`, 'i');
  const itemUrl = fullUrl.replace(regex, '');

  return getItemLocalUrl(itemUrl, itemId);
}

export function getItemUrl(itemUrl) {
  return `${config.baseUrl}/${itemUrl}`;
}

function replaceItemUrlWithFileName(path, newFileName) {
  const parts = path.split('/');
  const directory = parts[0];
  const fileName = parts[parts.length - 1];

  const extension = fileName.split('.').pop();

  return `${directory}/${newFileName}.${extension}`;
}

function replaceFontUrlWithFileName(fontUrl, fontId, organisationId) {
  const extension = fontUrl.split('.').pop().toLowerCase();
  return `${organisationId}/${fontId}.${extension}`;
}
